var React = require('react');

function Share (props) {
    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"share"),React.createElement("path",{"d":"M23.606 5.672l-3.985 3.983a.993.993 0 0 1-1.409 0 .995.995 0 0 1 0-1.408l2.285-2.284h-4.569c-4.321 0-7.97 3.558-7.97 7.768a.995.995 0 1 1-1.993 0c0-5.381 4.47-9.76 9.963-9.76h4.569l-2.285-2.283A.996.996 0 0 1 19.621.279l3.985 3.984a.996.996 0 0 1 0 1.409zm-17.641.291H1.98v13.943h17.933v-6.971a.996.996 0 0 1 1.993 0v6.971a1.995 1.995 0 0 1-1.993 1.992H1.98a1.994 1.994 0 0 1-1.992-1.992V5.963c0-1.097.894-1.992 1.992-1.992h3.985a.996.996 0 1 1 0 1.992z","key":1})]);
}

Share.displayName = "Share";

Share.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 23.906 21.906"};

module.exports = Share;

Share.default = Share;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/share.svg
// module id = 1285
// module chunks = 0